export const localizeHeaderLabel = (t, label) => {
  switch (label) {
  case 'API Docs':
    return t('title.apiDocs');
  case 'API Key':
    return t('title.apiKey');
  case 'Business Catalog':
    return t('title.businessCatalog');
  case 'Businesses':
    return t('title.businesses');
  case 'Catalog':
    return t('title.catalog');
  case 'Data':
    return t('title.data');
  case 'Dataset Marketplace':
    return t('title.datasetMarketplace');
  case 'Datasets':
    return t('title.datasets');
  case 'Export History':
    return t('title.exportHistory');
  case 'Similar Companies':
    return t('title.similarCompanies');
  default:
    return label;
  }
};
